// turn each script.gdpr-include tag into an equivalent script tag:
//   <script class="gdpr-include" content="%3Cscript%3Ealert('hello%20world')%3B%3Cscript%3E"></script>
//   --->
//   <script>alert('hello world');</script>
export function activateSnippets() {
  [...document.getElementsByClassName(`gdpr-include`)].forEach((snippet) => {
    const container = document.createElement(`div`);
    // eslint-disable-next-line no-unsanitized/property
    container.innerHTML = snippet.getAttribute(`content`);
    [...container.childNodes].forEach((node) => {
      snippet.parentNode.insertBefore(node, snippet);
    });
    snippet.parentNode.removeChild(snippet);
  });
}

// remove all script.gdpr-include tags from the document
export function removeSnippets() {
  [...document.getElementsByClassName(`gdpr-include`)].forEach((snippet) => {
    snippet.parentNode.removeChild(snippet);
  });
}
